import { render, staticRenderFns } from "./CodingHandles.vue?vue&type=template&id=3b5f2b86&"
import script from "./CodingHandles.vue?vue&type=script&lang=js&"
export * from "./CodingHandles.vue?vue&type=script&lang=js&"
import style0 from "./CodingHandles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports